<template>
  <section class="c-factlist">
    <h3 class="c-factlist__title">
      Fakta
    </h3>
    <ul class="c-factlist__list">
      <li
        v-if="residenceType.name"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Boligtype:</span>
        <span>{{ residenceType.name }}</span>
      </li>
      <li
        v-if="facts.bedrooms"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Soverom:</span>
        <span>{{ facts.bedrooms }}</span>
      </li>
      <li
        v-if="facts.bathrooms"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Bad:</span>
        <span>{{ facts.bathrooms }}</span>
      </li>
      <li
        v-if="facts.size"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Bruksareal:</span>
        <span>{{ facts.size }} m²</span>
      </li>
      <li
        v-if="facts.floorSize"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>P-rom:</span>
        <span>{{ facts.floorSize }} m²</span>
      </li>
      <li
        v-if="facts.grossSize"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Bruttoareal:</span>
        <span>{{ facts.grossSize }} m²</span>
      </li>
      <li
        v-if="facts.storage"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Bod:</span>
        <span>{{ facts.storage }} m²</span>
      </li>
      <li
        v-if="facts.plotsize"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Tomteareal:</span>
        <span>{{ facts.plotsize }} m²</span>
      </li>
      <li
        v-if="facts.floor"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Etasje:</span>
        <span>{{ facts.floor }}</span>
      </li>
      <li
        v-if="facts.terrace"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Terrasse:</span>
        <span>{{ facts.terrace }} m²</span>
      </li>
      <li
        v-if="facts.balcony"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Balkong:</span>
        <span>{{ facts.balcony }} m²</span>
      </li>
      <li
        v-if="facts.glazed_balcony"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Innglasset balkong:</span>
        <span>{{ facts.glazed_balcony }} m²</span>
      </li>
      <li
        v-if="facts.garden"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Hage:</span>
        <span>{{ facts.garden }} m²</span>
      </li>
      <li
        v-if="facts.garage && availability.slug !== 'sold'"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Garasje:</span>
        <span>{{ garage }}</span>
      </li>
      <li
        v-if="facts.carport && availability.slug !== 'sold'"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Carport:</span>
        <span>{{ carport }}</span>
      </li>
      <li
        v-if="facts.parking && availability.slug !== 'sold'"
        class="c-factlist__item c-factlist__item--border"
      >
        <span>Parkering:</span>
        <span>{{ facts.parking }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
import isInteger from 'lodash/isInteger';

// VUEX Models
import Availability from '@/models/Availability';
import Facts from '@/models/Facts';
import ResidenceType from '@/models/ResidenceType';

// UI Components

export default {
  name: 'Factlist',
  props: {
    id: {
      type: [
        Number,
        String,
      ],
      required: true,
    },
    // eslint-disable-next-line vue/prop-name-casing
    residencetype_id: {
      type: [
        Number,
        String,
        Boolean,
      ],
      required: false,
      default: false,
    },
  },
  computed: {
    facts() {
      return Facts.query()
        .where('residence_id', this.id)
        .first();
    },
    residenceType() {
      if (this.residencetype_id) {
        return ResidenceType.find(this.residencetype_id);
      } else {
        return false;
      }
    },
    availability() {
      return Availability.query()
        .whereHas('residences', query => {
          query.whereId(this.id);
        })
        .first();
    },
    garage() {
      if (isInteger(this.facts.garage)) {
        return this.facts.garage + ' m²';
      } else {
        return this.facts.garage;
      }
    },
    carport() {
      if (isInteger(this.facts.carport)) {
        return this.facts.carport + ' m²';
      } else {
        return this.facts.carport;
      }
    },
  },
};
</script>
